const fetchchallans = async () => {
  const response = await fetch(
    `${process.env.REACT_APP_BACKEND_URL}/getchallans/`,
    //`http://localhost:5000/getchallans/`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
      },
      body: JSON.stringify(),
    }
  );
  const json = await response.json();
  console.log("json.challans : ", json.challans);
  return Object.entries(json.challans);
};
const fetchLocalchallans = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/getlocalchallans/`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
        },
        body: JSON.stringify(),
      }
    );
    const json = await response.json();
    console.log("json.localchallans : ", json.localchallans);
    return Object.entries(json.localchallans);
  } catch (error) {
    console.error(error);
    // you can display a loading indicator or do other things here
  }
};

// ewayforms

const fetchEwayForms = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/getEwayforms/`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
        },
        body: JSON.stringify(),
      }
    );
    const json = await response.json();
    console.log("json.ewayforms : ", json.ewayForm);
    return Object.entries(json.ewayForm);
  } catch (error) {
    console.error(error);
    // you can display a loading indicator or do other things here
  }
};

const fetchLocalBilties = async () => {
  const response = await fetch(
    `${process.env.REACT_APP_BACKEND_URL}/getlbilties/`,
    //`http://localhost:5000/getlbilties/`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
      },
      body: JSON.stringify(),
    }
  );
  const json = await response.json();
  return Object.entries(json.biltys);
};
const fetchDrivers = async () => {
  const response = await fetch(
    `${process.env.REACT_APP_BACKEND_URL}/AllDriver/`,
    //`http://localhost:5000/AllDriver/`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
      },
      body: JSON.stringify(),
    }
  );
  const json = await response.json();
  return Object.entries(json.drive);
};

const fetchClients = async () => {
  const response = await fetch(
    `${process.env.REACT_APP_BACKEND_URL}/Allclient/`,
    //`http://localhost:5000/Allclient/`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
      },
      body: JSON.stringify(),
    }
  );
  const json = await response.json();
  return Object.entries(json.client);
};
export {
  fetchchallans,
  fetchLocalchallans,
  fetchLocalBilties,
  fetchDrivers,
  fetchClients,
  fetchEwayForms,
};
